var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVerticalExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "33px",
    viewBox: "0 0 70 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_vertical_expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.72893251,1 L57.2710675,1 C58.375637,1 59.2710675,1.8954305 59.2710675,3 C59.2710675,3.20431766 59.2397593,3.40742896 59.1782328,3.60226274 L54.4413907,18.6022627 C54.1786356,19.4343205 53.4067851,20 52.5342254,20 L7.46577462,20 C6.59321492,20 5.82136438,19.4343205 5.55860929,18.6022627 L0.82176718,3.60226274 C0.489146655,2.54896441 1.07337145,1.42545519 2.12666977,1.09283467 C2.32150355,1.03130821 2.52461485,1 2.72893251,1 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.3%",
    y: "-23.7%",
    width: "122.6%",
    height: "178.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.671167346   0 0 0 0 0.671167346   0 0 0 0 0.671167346  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.94,13 L29.2748227,15.2365465 C29.6753271,15.620193 30.3274736,15.6175103 30.7251773,15.2365465 L33.06,13 L33.2780176,13.2092969 C33.6767575,13.5920872 33.6726632,14.2166433 33.2848802,14.588915 L30.7151198,17.055885 C30.3201701,17.4350367 29.6726632,17.4281567 29.2848802,17.055885 L26.7151198,14.588915 C26.3201701,14.2097633 26.3182411,13.5968885 26.7219824,13.2092969 L26.94,13 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.94,1 L29.2748227,3.23654652 C29.6753271,3.62019304 30.3274736,3.61751025 30.7251773,3.23654652 L33.06,1 L33.2780176,1.20929687 C33.6767575,1.59208716 33.6726632,2.21664332 33.2848802,2.58891505 L30.7151198,5.05588495 C30.3201701,5.43503674 29.6726632,5.42815668 29.2848802,5.05588495 L26.7151198,2.58891505 C26.3201701,2.20976326 26.3182411,1.59688853 26.7219824,1.20929687 L26.94,1 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_vertical_expand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape-Copy",
    fill: "#517384",
    transform: "translate(30.000000, 15.371200) rotate(-359.000000) translate(-30.000000, -15.371200) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#517384",
    transform: "translate(30.000000, 3.371200) rotate(-179.000000) translate(-30.000000, -3.371200) ",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 9.5,
    x2: 47.5,
    y2: 9.5,
    id: "Path-2",
    stroke: "#C6C6C6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerticalExpand);
export default __webpack_public_path__ + "static/media/icon_vertical_expand.29fc3554dc06b5c333bcebb715b5422c.svg";
export { ForwardRef as ReactComponent };